import { StorageKeys } from './storage-keys';
import 'clientjs';
import { moniepointAppParameters } from './mobile-app-helper.model';

export interface Datalayer {
  event: string;
  step?: string;
  kyc_level?: string;
  email?: string;
  device_type?: string;
  device_id?: string;
  phone_number?: string;
  error_message?: string;
  onboarding_mode?: string;
  user_name?: string;
  city?: string;
  state?: string;
  lga?: string;
  religion?: string;
  business_name?: string;
  business_category?: string;
  business_type?: string;
  has_terminal?: string;
  cards_activated?: string;
  sign_in_mode?: string;
  api_error_message?: string;
  api_error_code?: string;
  employment_status?: string;
  marital_status?: string;
  mobile_version?: string;
  POA_skipped?: boolean;
  business_POA_skipped?: boolean;
  has_cards?: boolean;
  pos_activated?: boolean;
  platform?: string;
  payment_type?: string;
  transaction_amount?: any;
  user_type?: string;
  business_owner_first_name?: string;
  wallet_type?: string;
  referral_code?: string;
  terminal_id?: any;
  user_id?: any;
  timestamp?: string;
  name_of_business_assigned?: any;
  number_of_cartons_requested?: any;
  liveness_provider?: any;
  domain?: any;
  app_env?: string;
  longitude?: number;
  latitude?: number;
  auth_type?: string;
  auth_type_provider?: string;
  feature?: string;
}

export const enum EventName {
  sign_in_success = "sign_in_success",
  identify_user = "identify_user",
  page_change = "page_change",
  reset_user = "reset_user",
  allow_in_app_messaging = "allow_in_app_messaging",
  cancel_in_app_messaging = "cancel_in_app_messaging",
}


export const enum PaymentEventName {
  PAYMENT_INITIATED = "payment_initiated",
  PAYMENT_FAILED = "payment_failed",
  PAYMENT_SUCCESS = "payment_success",
}

export type DatalayerPayload = Omit<Datalayer, 'event'>;

export function initializeDatalayer(event: string) {
  const deviceInformation = moniepointAppParameters()?.deviceRegistrationRequest;
  const datalayer: Datalayer = { event };
  datalayer.phone_number = localStorage.getItem(StorageKeys.businessNumber) || '';
  datalayer.user_name = localStorage.getItem(StorageKeys.username) || '';
  datalayer.email = localStorage.getItem(StorageKeys.email) || '';
  datalayer.business_name = localStorage.getItem(StorageKeys.businessName) || '';
  datalayer.business_category = localStorage.getItem(StorageKeys.business_category) || '';
  datalayer.business_type = localStorage.getItem(StorageKeys.business_type) || '';
  datalayer.onboarding_mode = localStorage.getItem('on_boarding_mode') || 'BRM';
  datalayer.device_id = deviceInformation?.deviceUniqueIdentifier;
  datalayer.device_type = deviceInformation?.model;
  datalayer.platform = localStorage.getItem('device_client_type') || 'WEB';
  datalayer.user_type = localStorage.getItem('USER_ROLE') || '';
  datalayer.business_owner_first_name = localStorage.getItem(StorageKeys.firstName) || '';
  datalayer.domain = localStorage.getItem('authenticationDomain') || '';
  const token: any = localStorage.getItem('SAVED_TOKEN_DATA');
  try {
    const tokenData = JSON.parse(token);
    datalayer.user_id = tokenData?.userId;
  } catch (e) { }
  return datalayer;
}

export function updateDatalayerIdentifyUser(datalayer: Datalayer) {
  datalayer.city = '';
  datalayer.state = '';
  datalayer.lga = '';
  datalayer.business_name = '';
  datalayer.business_category = '';
  datalayer.business_type = '';
  datalayer.has_terminal = '';
  datalayer.cards_activated = '';
  return datalayer;
}
